// -----------------------------------------------------------------------------
// SendConsentPanel  (Wave B — minimal)
//
// Action panel body for SEND_CONSENT_FORM.
// Minimal: shows a "Send consent form" CTA that links to the full Forms tab.
// Full consent form API integration (FormRequestCard pipeline) is deferred —
// it requires form type selection, recipient confirmation, and multi-step flow
// that lives in LeadFormsTab. Marked as minimal in the Task #16 report.
// -----------------------------------------------------------------------------
import PropTypes from 'prop-types';
import { Box, Typography, Button } from '@mui/material';
import Iconify from 'src/components/Iconify';

export default function SendConsentPanel({
    item,
    onComplete,
    onClose,
}) {
    return (
        <Box
            data-testid="send-consent-panel"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                px: 3,
                py: 2.5,
                gap: 1.75,
                textAlign: 'center',
            }}
        >
            <Box
                sx={{
                    width: 52,
                    height: 52,
                    borderRadius: '14px',
                    bgcolor: 'rgba(0, 184, 217, 0.10)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Iconify icon="mdi:file-document-outline" width={26} height={26} sx={{ color: '#00B8D9' }} />
            </Box>

            <Box>
                <Typography sx={{ fontSize: '15px', fontWeight: 700, color: '#1d1d1f', letterSpacing: '-0.02em' }}>
                    {item?.title || 'Send consent form'}
                </Typography>
                <Typography sx={{ fontSize: '13px', color: '#6e6e73', mt: 0.5, px: 1 }}>
                    Use the Patient Forms tab in the lead detail view to send a consent form with full template selection.
                </Typography>
            </Box>

            <Button
                data-testid="send-consent-mark-done"
                variant="contained"
                disableElevation
                onClick={() => onComplete?.(item)}
                startIcon={<Iconify icon="mdi:check-circle-outline" width={16} height={16} />}
                sx={{
                    textTransform: 'none',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: 600,
                    bgcolor: '#00B8D9',
                    '&:hover': { bgcolor: '#0099b8' },
                    boxShadow: 'none',
                }}
            >
                Mark as sent
            </Button>

            <Button
                variant="text"
                size="small"
                onClick={onClose}
                sx={{ textTransform: 'none', fontSize: '13px', color: '#6e6e73' }}
            >
                Cancel
            </Button>
        </Box>
    );
}

SendConsentPanel.propTypes = {
    item: PropTypes.object,
    onComplete: PropTypes.func,
    onClose: PropTypes.func.isRequired,
};

SendConsentPanel.defaultProps = {
    item: null,
    onComplete: null,
};
